/* Al actualizar estos catalogos, actualizar también en el backend/db/models/Unidad.js */

const ACTIVIDADES = [
    { value: "no-aplica", label: "No Aplica" },
    { value: "activos_virtuales", label: "Activos Virtuales" },
    { value: "arrendamiento", label: "Arrendamiento" },
    { value: "blindaje", label: "Blindaje" },
    { value: "cheques_viajero", label: "Cheques de Viajero" },
    { value: "comercio_exterior", label: "Comercio Exterior" },
    { value: "custodia_valores", label: "Custodia de Valores" },
    { value: "inmobiliaria", label: "Inmobiliaria" },
    { value: "donativos", label: "Donativos" },
    { value: "fe_publica", label: "Fe Pública" },
    { value: "intermediacion_inmuebles", label: "Intermediación Inmuebles" },
    { value: "joyas_metales", label: "Joyas y Metales" },
    { value: "juegos_apuesta", label: "Juegos con Apuesta" },
    { value: "monederos_recompensas", label: "Monederos y Recompensas" },
    { value: "mutuo_credito", label: "Mutuo/Préstamo/Crédito" },
    { value: "obras_arte", label: "Obras de Arte" },
    { value: "servicios_profesionales", label: "Servicios Profesionales" },
    { value: "servidores_publicos", label: "Servidores Públicos" },
    { value: "tarjetas_credito", label: "Tarjetas de Crédito" },
    { value: "tarjetas_prepago", label: "Tarjetas Prepagadas" },
    { value: "vehiculos", label: "Vehículos" }
];

const TIPO_ACTIVIDAD_VULNERABLE = [
    { id: 1, riesgo: 'medio-bajo', name: 'Derechos Personales de Uso o Goce de Inmuebles (Arrendamiento)', value: 'arrendamiento' },
    { id: 2, riesgo: 'medio-bajo', name: 'Transmisión de Derechos Sobre Bienes Inmuebles (Intermediación / Compraventa)', value: 'intermediacion_inmuebles' },
    { id: 3, riesgo: 'medio', name: 'Mutuo, Préstamo o Créditos', value: 'mutuo_credito' },
    { id: 4, riesgo: 'medio-bajo', name: 'Servicios Profesionales Independientes', value: 'servicios_profesionales' },
    { id: 5, riesgo: 'medio-bajo', name: 'Desarrollo Inmobiliario', value: 'inmobiliaria' },
    { id: 6, riesgo: 'medio-bajo', name: 'Recepción de Donativos', value: 'donativos' },
    { id: 7, riesgo: 'medio', name: 'Vehículos Aéreos, Marítimos o Terrestres', value: 'vehiculos' },
    { id: 8, riesgo: 'medio', name: 'Fe Pública', value: 'fe_publica' },
    { id: 9, riesgo: 'alto', name: 'Metales, Piedras Preciosas, Joyas o Relojes', value: 'joyas_metales' },
    { id: 10, riesgo: 'bajo', name: 'Servicios de Comercio Exterior', value: 'comercio_exterior' },
    { id: 11, riesgo: 'medio', name: 'Tarjetas Prepagadas, Vales o Cupones', value: 'tarjetas_prepago' },
    { id: 12, riesgo: 'alto', name: 'Obras de Arte', value: 'obras_arte' },
    { id: 13, riesgo: 'medio-bajo', name: 'Juegos con Apuesta, Concursos o Sorteos', value: 'juegos_apuesta' },
    { id: 14, riesgo: 'medio-bajo', name: 'Tarjetas de Servicios o De Crédito', value: 'tarjetas_credito' },
    { id: 15, riesgo: 'medio-bajo', name: 'Traslado o Custodia de Dinero o Valores', value: 'custodia_valores' },
    { id: 16, riesgo: 'medio-bajo', name: 'Servicios de Blindaje', value: 'blindaje' },
    { id: 17, riesgo: 'medio', name: 'Servidores Públicos', value: 'servidores_publicos' },
    { id: 18, riesgo: 'medio-bajo', name: 'Operaciones con Activos Virtuales', value: 'activos_virtuales' },
    { id: 19, riesgo: 'alto', name: 'Monederos y Certificados de Devoluciones o Recompensas', value: 'monederos_recompensas' },
    { id: 20, riesgo: 'bajo', name: 'Cheques de Viajero', value: 'cheques_viajero' },
]


export { ACTIVIDADES, TIPO_ACTIVIDAD_VULNERABLE };
